export default "__VITE_ASSET__McIYk0fZ__"